





















































































import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import {
  Meter,
  ResCode,
  PowerConditionerTableData,
  Fireware,
  PagingReq,
  SimplifyMeter,
} from "@/api/baseDefine";
import {
  FirewareCommonReq,
  geFirewares,
  createFireware,
  updateFireware,
  deleteFireware,
} from "@/api/fireware";
import {
  SendDataReq,
  sendData,
  meters,
  GetPowerConditionerDataReq,
  getPowerConditionerData,
  PowerConditioner,
} from "@/api/meter";
import { formatDate, formatDateTime } from "../../utils/dateUtil";
import XLSX from "xlsx";
@Component
export default class FirewareUpgradeDialog extends Vue {
  @Prop({ default: null, required: true }) private meters!: Meter[];
  private firewareUpgradeDialogShow: boolean = false;
  private firewareList: Fireware[] = [];
  private showUploadFile = false;
  private showTable = false;
  private searchFireware: Fireware = <Fireware>{};
  private selectFirewareID = "";
  private loading = false;
  private sendEnable = false;
  private clickShow() {
    console.log("clickShow", this.meters);
    this.showTable = false;
    if (this.meters.length <= 0) {
      this.showUploadFile = true;
      this.sendEnable = true;
      // this.$notify({
      //   title: this.$t("common.warning").toString(),
      //   message: this.$t("powerConditioner.onlyOneMeterSupport").toString(),
      //   type: "warning",
      // });
      // return;
    } else {
      this.showUploadFile = false;
      this.sendEnable = true;
    }
    this.firewareUpgradeDialogShow = true;
  }
  private async queryFireware(query) {
    let req: FirewareCommonReq = <FirewareCommonReq>{};
    req.page = 1;
    req.pageSize = 300;
    req.fireware = this.searchFireware;
    req.fireware.meterTypeID = this.searchFireware.meterTypeID;
    req.fireware.name = query;
    this.loading = true;
    const res = await geFirewares(req);
    if (res.code === ResCode.SUCCESS) {
      this.firewareList = res.data.firewares.list;
    }
    this.loading = false;
  }
  private async onSelectFireware(b) {
    if (b) {
      this.queryFireware("");
    }
  }
  private async sendFireware() {
    if (this.meters.length <= 0) {
      return;
    }
    let selectFireware: Fireware = <Fireware>{};
    for (let i = 0; i < this.firewareList.length; i++) {
      if (this.selectFirewareID == this.firewareList[i].id.toString()) {
        selectFireware = this.firewareList[i];
      }
    }
    console.log("sendFireware", selectFireware);
    if (selectFireware.id <= 0) {
      return;
    }
    let req: SendDataReq = <SendDataReq>{};
    req.meterIDs = this.getMeterIDs();
    req.dataType = 31;
    req.params = "0," + selectFireware.url + ",";
    if (selectFireware.firmwareType == "gateway_wifi") {
      req.dataType = 30;
      req.params = req.params + selectFireware.version;
    } else if(selectFireware.firmwareType == "cert"){
      req.dataType = 29;
      req.params = req.params + selectFireware.version;
    } else if (selectFireware.firmwareType == "ca_cert") {
      req.dataType = 29;
      req.params = req.params + "cacert##";
    } else if (selectFireware.firmwareType == "client_cert") {
      req.dataType = 29;
      req.params = req.params + "clientce";
    } else if (selectFireware.firmwareType == "client_key") {
      req.dataType = 29;
      req.params = req.params + "clientke";
    } else if (selectFireware.firmwareType == "pcs_ca_ert") {
      req.dataType = 29;
      req.params = req.params + "pcsca###";
    }else if (selectFireware.firmwareType == "meter") {
      req.dataType = 28;
      req.params = req.params + selectFireware.version;
    } else if (selectFireware.firmwareType == "bootloader") {
      req.dataType = 26;
      req.params = req.params + selectFireware.version;
    } else {
      req.params = req.params + selectFireware.version;
    }

    const res = await sendData(req);
    if (res.code === ResCode.SUCCESS) {
      // this.dialogBatchWrite = false;
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.dataPackageSendSuccess").toString(),
        type: "success",
      });
    }
  }
  private getMeterIDs() {
    let meterIDS: {
      meterID: string;
      meterTypeID: number;
    }[] = [];
    for (let item of this.meters) {
      let meterID: {
        meterID: string;
        meterTypeID: number;
      } = {
        meterID: item.meterID,
        meterTypeID: item.meterTypeID,
      };
      meterIDS.push(meterID);
    }
    return meterIDS;
  }

  private onChange(file) {
    // // 拿取文件对象
    var f = file.raw;
    // // 用FileReader来读取
    var reader = new FileReader();
    let self = this;
    // 重写FileReader上的readAsBinaryString方法
    self.meters = [];
    FileReader.prototype.readAsBinaryString = function (file) {
      var binary = "";
      var wb; // 读取完成的数据
      var outdata: string[][]; // 你需要的数据
      var reader = new FileReader();
      reader.onload = function (ev) {
        // 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
        // console.log(reader.result);
        let result: any = reader.result;
        var bytes = new Uint8Array(result);
        var length = bytes.byteLength;
        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        // console.log("binary", binary);
        // 接下来就是xlsx了，具体可看api
        wb = XLSX.read(binary, {
          type: "binary",
        });

        outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], {
          header: 1,
          defval: "",
        });

        console.log("getResult", outdata);
        if (outdata.length > 0) {
          for (let data of outdata) {
            if (data.length == 2) {
              let meter: Meter = <Meter>{};
              meter.meterID = data[0];
              meter.meterTypeID = Number(data[1]);
              self.meters.push(meter);
            }
          }
        }

        if (self.meters.length > 0) {
          self.showTable = true;
        }
        // 自定义方法向父组件传递数据
        // that.$emit("getResult", outdata);
      };
      reader.readAsArrayBuffer(f);
    };
    reader.readAsBinaryString(f);
  }
}
